// Temporary stub for @bheem/design-client until npm auth is fixed
// This provides a no-op DesignProvider that just renders children

import type { ReactNode } from 'react'

interface DesignProviderProps {
  children: ReactNode
  workspaceId?: string
  orchestratorUrl?: string
  surface?: string
  industry?: string
}

export function DesignProvider({ children }: DesignProviderProps) {
  return <>{children}</>
}
